import React, { useEffect, useState } from 'react'
import { Modal, Row, Col, Button } from 'react-bootstrap'
import { InputPicker, Form, Schema } from 'rsuite';
import Swal from 'sweetalert2';
import RedStar from '../../../../Shared/GenericComponents/RedStar';
import examTabService from '../../../../../services/Internal/Credential/examTab.service';
import { getExamDiscipline, getExamStatuses } from '../../../../../services/Shared/codeTable.service';
import TextArea from '../../../../Shared/GenericComponents/TextArea';

function ExamsTabModal(props) {
    const [exams, setExams] = useState([]);
    const [examStatuses, setExamStatuses] = useState([]);
    const [recordModel, setRecordModel] = useState({
        dateCrte: new Date(),
        deleted: false,
        entityId: '',
        examDate: null,
        id: '',
        comments: '',
        examDiscipline: null,
        status: null,
        userCrte: '',
        modalType: "Add"
    })
    useEffect(() => {
        getExamDiscipline().then(setExams);
        getExamStatuses().then(setExamStatuses);
    }, [])
    useEffect(() => {
        setRecordModel({
            ...props.modaldata
        });
    }, [props.modaldata])
    const { ObjectType, StringType } = Schema.Types;
    const model = Schema.Model({
        examDiscipline: ObjectType().isRequired('This field is required.'),
        examDate: StringType().when(schema => {
            return recordModel?.status?.status == 'Waived' ? StringType() : StringType().isRequired('This field is required.');
        })
    })
    const formSubmit = (validation, event) => {
        if (validation) {
            var dataToTransmit = {
                ...recordModel,
                id: recordModel.id === '' ? 0 : recordModel.id,
                attendanceEndDate: recordModel.attendanceEndDate ? new Date(recordModel.attendanceEndDate) : null,
                examDate: recordModel.examDate ? new Date(recordModel.examDate) : null,
                attendanceStartDate: recordModel.attendanceStartDate ? new Date(recordModel.attendanceStartDate) : null,
                graduationDate: recordModel.graduationDate ? new Date(recordModel.graduationDate) : null
            };
            delete dataToTransmit.modalType;
            examTabService.saveExam(dataToTransmit).then((response) => {
                if (response.data.id) {
                    Swal.fire("Success!", "You have successfully updated an exam record.", "success");
                    props.updateGrid();
                    props.onHide();
                }
            }).catch((response) => {
            })
        }
    }
    return (
        <Modal
            {...props}
            animation={false}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    {recordModel.modalType} an Exam Record
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form id="recordForm" fluid model={model} formValue={recordModel} onChange={recordModel => setRecordModel(recordModel)} onSubmit={formSubmit} >
                    <Form.Group>
                        <Row>
                            <Col sm={3}>
                                <Form.ControlLabel>
                                    <strong>Exam Date&nbsp;<RedStar /></strong>
                                </Form.ControlLabel>
                            </Col>
                            <Col sm={9}>
                                <Form.Control type="date" block name="examDate" />
                            </Col>
                        </Row>
                    </Form.Group>
                    <Form.Group>
                        <Row>
                            <Col sm={3}>
                                <Form.ControlLabel>
                                    <strong>
                                        Exam&nbsp;<RedStar />
                                    </strong>
                                </Form.ControlLabel>
                            </Col>
                            <Col sm={9}>
                                <Form.Control
                                    block
                                    name="examDiscipline"
                                    placeholder="Select an Exam"
                                    accepter={InputPicker}
                                    data={exams} />
                            </Col>
                        </Row>
                    </Form.Group>
                    <Form.Group>
                        <Row>
                            <Col sm={3}>
                                <Form.ControlLabel>
                                    <strong>
                                        Status
                                    </strong>
                                </Form.ControlLabel>
                            </Col>
                            <Col sm={9}>
                                <Form.Control
                                    block
                                    name="status"
                                    placeholder="Select a Status"
                                    accepter={InputPicker}
                                    data={examStatuses} />
                            </Col>
                        </Row>
                    </Form.Group>
                    <Form.Group>
                        <Row>
                            <Col sm={3}>
                                <Form.ControlLabel>
                                    <strong>
                                        Comments
                                    </strong>
                                </Form.ControlLabel>
                            </Col>
                            <Col sm={9}>
                                <Form.Control accepter={TextArea} rows={5} name="comments" maxLength={500} />
                            </Col>
                        </Row>
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button type="submit" form="recordForm" variant="success">Save</Button>
                <Button onClick={props.onHide}>Close</Button>
            </Modal.Footer>
        </Modal>
    );
}
export default ExamsTabModal;